define((require) => {
    "use strict";

    var Marionette         = require("marionette"),
        ShareRecipientView = require("ui/share/ShareRecipientView");

    /**
     * The collection view of share recipients.
     *
     * @author Bruce Mackenzie Nielsen
     * @class ShareRecipientCollectionView
     * @constructor
     */
    return Marionette.CompositeView.extend({
        template: function() { return ""; },
        itemView: ShareRecipientView
    });
});



// WEBPACK FOOTER //
// ./src/editor/ui/share/ShareRecipientCollectionView.js